const EMEA_PHONE_KEYS: Record<string, string> = {
  GB: "ukContactPhone",
  AT: "austriaContactPhone",
  CH: "switzerlandContactPhone",
  DE: "germanContactPhone",
  IE: "irelandContactPhone",
};

export const getEmeaContactPhoneKey = (country: string): string =>
  EMEA_PHONE_KEYS[country] ?? "contactPhone";
